<template>
  <div
    v-if="isWebViewFlag && canShareFlag"
    class="share"
    :class="category === 'TOP' ? 'isTop' : ''"
  >
    <p
      class="share__text"
      @click="shareThisPage()"
    >
      このページをシェア
    </p>
  </div>
</template>

<script setup>
const {
  compareVersion,
  getVersion,
  isWebview
} = await import('@weathernews/btos-javascript-modules/src/wniutil/common.js')

const props = defineProps({
  category: { type: String, default: '' },
  title: { type: String, default: '' }
})

const url = useRequestURL()

const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()

const validShareApp = ref(false)
// CSR時のCLS低減のため、 isWebViewFlag で判定するから、デフォルトは true にしておく
const canShareFlag = ref(true)

const shareContent = {
  title: props.title,
  url: url.origin + url.pathname + '?share=1'
}

const shareThisPage = async () => {
  if (validShareApp.value) {
    location.href = 'weathernews://weathernews.jp/share_web?url=' + encodeURI(shareContent.url)
  } else {
    try {
      await window.navigator.share(shareContent)
    } catch (err) {
      console.log(err)
    }
  }
}

onMounted(async () => {
  const appVer = getVersion()
  validShareApp.value = Boolean(appVer && appVer.length > 0 && compareVersion(appVer, '5.43.0') >= 0)
  if (isWebview) {
    if (validShareApp.value) {
      canShareFlag.value = true
    } else {
      if (window.navigator.share != 'undefined' && window.navigator.share) {
        canShareFlag.value = true
      } else {
        canShareFlag.value = false
      }
    }
  }
})
</script>

<style lang="scss" scoped>
.share {
  text-align: right;

  &.isTop {
    margin-top: 10px;
  }

  &__text {
    display: inline-block;
    padding-left: 15px;
    color: black;
    font-size: 12px;
    font-weight: 500;
    line-height: 13px;
    text-decoration: underline;
    background-image: url('~/assets/images/common/icon_share.svg');
    background-position: left center;
    background-repeat: no-repeat;
    background-size: contain;
  }

  @media (any-hover: hover) {
    &__text {
      cursor: pointer;
      transition: opacity 0.3s ease-in-out;

      &:hover {
        opacity: 0.6;
      }
    }
  }
}
</style>
